import React from "react";
import ToggleSwitch from "~/components/ToggleSwitch";
import { useClaimRewards } from "~/hooks/useClaimRewards";
import { ClaimRewardsToggleStyled } from "./ClaimRewardsToggleStyled";

interface ClaimRewardsToggleProps {
  className?: string;
  as?: React.ElementType;
}

const ClaimRewardsToggle: React.FC<ClaimRewardsToggleProps> = ({ className, as }) => {
  const { checked, toggle, displayRewards } = useClaimRewards();

  if (!displayRewards) {
    return null;
  }

  const StyledWrapper = as || ClaimRewardsToggleStyled;

  return (
    <StyledWrapper className={className}>
      <p>Claim Rewards</p>
      <ToggleSwitch checked={checked} onChange={toggle} />
    </StyledWrapper>
  );
};

ClaimRewardsToggle.displayName = "ClaimRewardsToggle";

export default ClaimRewardsToggle;
